const getImageProcessingLabelKey = ({ hasError, isSlow, compact }) => {
  if (hasError) return compact ? 'imageProcessingFailedShort' : 'imageProcessingFailed';
  if (compact) return 'imageProcessingShort';
  if (isSlow) return 'imageProcessingSlow';
  return 'imageProcessing';
};

export default getImageProcessingLabelKey;
